import axiosClient from "../../../api/apiClient";

export const APIPostImportUsers = (data: object) => {
    return axiosClient.post(`/import/school`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const APIPostExampleUrl = () => {
    return axiosClient.post(`/import`);
};